import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { LeadsProvider } from './contexts/LeadsContext';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { WhatsAppFab } from './components/WhatsAppFab';
import { ScrollToTop } from './components/ScrollToTop';
import { PixelTracker } from './components/PixelTracker';
import { ExternalRedirect } from './components/ExternalRedirect';
import { Home } from './pages/Home';
import { Financiacion } from './pages/Financiacion';
import { SimulacionCredito } from './pages/SimulacionCredito';
import { FinanciarUsado } from './pages/FinanciarUsado';
import { VenderAuto } from './pages/VenderAuto';
import { Permutas } from './pages/Permutas';
import { Contacto } from './pages/Contacto';
import { CATALOGO_URL } from './data/brand';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="28s2zfehuu3wi">
      <LeadsProvider data-id="element-1" data-mp="23vkuadim43jn">
        <div className="flex min-h-screen w-full flex-col bg-ink" data-id="element-2" data-mp="23u9t8lgjx9w8">
          <ScrollToTop data-id="element-3" data-mp="3ijxsv0nzqion" />
          <PixelTracker data-id="element-4" data-mp="3ikqy1x7ax04o" />
          <Header data-id="element-5" data-mp="3ijfvu1ti80fo" />
          <div className="flex-1" data-id="element-6" data-mp="3ihv2ugmu8pjx">
            <Routes data-id="element-7" data-mp="3ml14tc2x3ukl">
              <Route path="/" element={<Home data-id="element-9" data-mp="3mjzpuwis6nxl" />} data-id="element-8" data-mp="3mkhm3t5g125i" />
              {/* El catálogo vive en el sitio oficial: los links viejos redirigen. */}
              <Route path="/catalogo" element={<ExternalRedirect to={CATALOGO_URL} data-id="element-11" data-mp="5orv1p50w72" />} data-id="element-10" data-mp="3recedkz46pg7" />
              <Route path="/vehiculos/*" element={<ExternalRedirect to={CATALOGO_URL} data-id="element-13" data-mp="2zm4yimrfnh2v" />} data-id="element-12" data-mp="56n1goet9nj" />
              <Route path="/financiacion" element={<Financiacion data-id="element-15" data-mp="33nq921ghvj9w" />} data-id="element-14" data-mp="33mf25srr5vek" />
              <Route path="/simulacion-credito" element={<SimulacionCredito data-id="element-17" data-mp="38l8hlqqlnwhd" />} data-id="element-16" data-mp="33orjq4tlm3r3" />
              <Route path="/financiar-usado" element={<FinanciarUsado data-id="element-19" data-mp="3dkuvm2e95gr8" />} data-id="element-18" data-mp="38k6wetfvdtlx" />
              <Route path="/vender-mi-auto" element={<VenderAuto data-id="element-21" data-mp="3dirtwl3qlz6o" />} data-id="element-20" data-mp="3dlw5i3jj7x7d" />
              <Route path="/permutas" element={<Permutas data-id="element-23" data-mp="nuhjilyq8hvv" />} data-id="element-22" data-mp="nvstj3irmlvf" />
              <Route path="/contacto" element={<Contacto data-id="element-25" data-mp="sudkecc4nt77" />} data-id="element-24" data-mp="nxn5vtfz15nw" />
              <Route path="*" element={<Home data-id="element-27" data-mp="st2k4mhw53ku" />} data-id="element-26" data-mp="stko65asom3b" />
            </Routes>
          </div>
          <Footer data-id="element-28" data-mp="35oz0whm5evr" />
          <WhatsAppFab data-id="element-29" data-mp="356sn718lka4" />
        </div>
      </LeadsProvider>
    </BrowserRouter>;
}